//this comes from the deploy-time realmConfig.js, imported by index.html
//in unit test, jest.presets.js sets this as a global
declare const realmConfig: any
declare const dockerTag: any

export type Realm = 'alpha' | 'beta' | 'stg1' | 'prd1'
export type CwanEnvironment = 'unittest' | 'dev' | 'staging' | 'prod'

/**
 * This is identical to realmConfig.alpha.js, but we just paste it here so Typescript knows the schema,
 *   and also so that localhost dev just works without any changes
 * to change realmConfig during localhost development, edit index.html to specify which one you want
 */
export const environment = {
  realm: 'alpha' as Realm,
  environment: 'dev' as CwanEnvironment,
  production: false,
  test: false,
  auth0: {
    domain: 'auth.beta.cwan.io',
    audience: 'https://core.clearwateranalytics.com',
    organization: 'org_o27ieGG1xliIqiJC',
    clientId: 'n6t3pYTt4DAAZFwhVpvWDnQ6cOGaK11b',
    redirectUri: `${window.location.origin}/helios`,
    useRefreshTokens: true,
  },
  externalComponents: {
    securityDetail:
      'https://security-details.uswe2.beta.aws.cwan.io/security-details.js',
    sidenavBaseUrl: 'https://console.uswe2.beta.aws.cwan.io/nav/',
    counterPartyUrl:
      'https://counter-party-ui.uswe2.beta.aws.cwan.io/counterparty/',
    securityMapping:
      'https://security-mapping-ui.uswe2.beta.aws.cwan.io/security-mapping-ui.js',
    reconInsightInternalUIUrl:
      'https://recon-insight-internal-ui.uswe2.beta.aws.cwan.io/recon-insight-internal-ui/',
    outputManager:
      'https://recon-aggregator-ui.uswe2.beta.aws.cwan.io/recon-aggregator-ui.js',
    clarityOpsVisualizer:
      'https://clarity-ops-visualizer-ui.uswe2.beta.aws.cwan.io/clarity-ops-visualizer-ui.js',
  },
  dockerTag: dockerTag ? dockerTag.split('-').at(-1) : null,
  ...realmConfig, //override with realm-specific settings from realmConfig.js
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
